import axios, { AxiosRequestConfig } from 'axios';

export class OffPlanApi {
  async verifyOffPlan(data: any, signal?: AbortSignal) {
    try {
      const res = await axios.post(`/api/CallPlan/VerifyOffPlan`, data, { signal });
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}
